import { Subject, defer } from 'rxjs';

import { SystemApi } from '~/api/system';

class SystemServiceClass {
  private messageSubject: Subject<string>;

  constructor() {
    this.messageSubject = new Subject();
  }

  getSystemMessage() {
    SystemApi.getMessage().then((message) => {
      this.messageSubject.next(message);
    });

    return this.messageSubject.asObservable();
  }

  setSystemMessage(message: string) {
    SystemApi.create({ message }).then((data: string) => {
      this.messageSubject.next(data);
    });
  }

  getImportLog(page: number) {
    return defer(() => SystemApi.getAllImportLogs(page));
  }
}

export const SystemService = new SystemServiceClass();
